module.exports = __webpack_public_path__ + "static/img/line-button-v26.4aed0ae.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/btn_social/line-button-v26.webp
// module id = 3Q8b
// module chunks = 134